(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin-data/games/assets/javascripts/services/remove-game.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin-data/games/assets/javascripts/services/remove-game.js');
"use strict";


const removeGame = (activatedDrawId, callback) => {
  svs.core.jupiter.delete("/retailer/1/marketplace/activateddraws/".concat(activatedDrawId), () => {
    callback(undefined);
  }, error => {
    callback(error.responseJSON.error);
  });
};
setGlobal('svs.components.marketplaceRetailAdminData.games.services.removeGame', removeGame);

 })(window);